import React, { useContext, useEffect } from "react";
import { Divider } from "antd";
import Hydration from "./GeneralExaminationComponents/Hydration";
import LevelOfConsciousness from "./GeneralExaminationComponents/LevelOfConsciousness";
import Pupils from "./GeneralExaminationComponents/Pupils";
import Pallor from "./GeneralExaminationComponents/Pallor";
import Icterus from "./GeneralExaminationComponents/Icterus";
import Cyanosis from "./GeneralExaminationComponents/Cyanosis";
import Edema from "./GeneralExaminationComponents/Edema";
import PainScale from "./GeneralExaminationComponents/PainScale";
import VitalsAdmission from "./GeneralExaminationComponents/VitalsAdmission";
import { DailyReviewContext } from "../../../Doctor/DailyReview/DailyReviewFormProvider";
import PhysioGcs from "./GeneralExaminationComponents/PhysioGcs";

const DrGeneralExaminationFormDR = ({ form }) => {
  const { formData } = useContext(DailyReviewContext);
  useEffect(() => {
    const dataToSet = formData?.general_examination;
    form.setFieldsValue(dataToSet);
  }, [formData]);
  return (
    <div className="daily-review-gen-exam">
      <LevelOfConsciousness context={DailyReviewContext} form={form} />
      <Divider />
      <PhysioGcs formData={formData} form={form} />
      <Divider />

      <Pupils context={DailyReviewContext} form={form} />
      <Divider />

      <Hydration form={form} />
      <Divider />
      <Pallor form={form} />
      <Divider />

      <Icterus form={form} />
      <Divider />

      <Cyanosis form={form} />
      <Divider />

      <Edema context={DailyReviewContext} form={form} />
      <Divider />

      <VitalsAdmission />
      <Divider />

      <PainScale context={DailyReviewContext} form={form} />
    </div>
  );
};

export default DrGeneralExaminationFormDR;
